module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Loading', {
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), _c('router-view', {
    on: {
      "reload": function($event) {
        return _vm.fetch(true)
      }
    }
  }), _vm._v(" "), (!_vm.archivedOrders.length && !_vm.loading) ? _c('div', {
    staticClass: "no-orders"
  }, [_c('p', [_vm._v("Hittade inga tidigare resor.")])]) : _vm._e(), _vm._v(" "), (_vm.archivedOrders.length) ? _c('div', {
    staticClass: "booking-group"
  }, [_c('h2', [_vm._v("Tidigare resor")]), _vm._v(" "), _c('table', {
    class: {
      disabled: _vm.loading
    }
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.archivedOrders), function(orders) {
    return _c('tbody', [_c('tr', [_c('th', {
      staticStyle: {
        "background-color": "white",
        "text-align": "left"
      },
      attrs: {
        "colspan": "4"
      }
    }, [_c('h3', {
      staticStyle: {
        "margin-bottom": "0",
        "margin-top": "1em",
        "margin-left": "10px"
      }
    }, [_vm._v(_vm._s(orders[0].season))])])]), _vm._v(" "), _vm._l((orders), function(order) {
      return _c('tr', {
        staticClass: "table-row"
      }, [_c('td', [_c('span', {
        staticClass: "mobile-title"
      }, [_vm._v("Bokningsnr")]), _vm._v("\n            " + _vm._s(order.resvid) + "\n          ")]), _vm._v(" "), _c('td', {
        staticClass: "center"
      }, [_c('span', {
        staticClass: "mobile-title"
      }, [_vm._v("Ankomst")]), _vm._v("\n            " + _vm._s(order.arrivaldate.substr(0, 10)) + "\n          ")]), _vm._v(" "), _c('td', {
        staticClass: "right"
      }, [_c('span', {
        staticClass: "mobile-title"
      }, [_vm._v("Summa")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(order.sum)))])]), _vm._v(" "), _c('td', {
        staticClass: "center wide"
      }, [_c('button', {
        staticClass: "white border small",
        on: {
          "click": function($event) {
            return _vm.goToBooking(order.headlid)
          }
        }
      }, [_c('icon', {
        attrs: {
          "name": "info-blue",
          "scale": 1.3
        }
      }), _vm._v(" Visa bokning")], 1)])])
    })], 2)
  })], 2)]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Bokningsnummer")]), _vm._v(" "), _c('th', {
    staticClass: "center"
  }, [_vm._v("Ankomst")]), _vm._v(" "), _c('th', {
    staticClass: "right"
  }, [_vm._v("Summa")]), _vm._v(" "), _c('th', {
    staticClass: "center"
  }, [_vm._v("Information")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17ec2a76"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/MyPages/MyPageBookings.vue
// module id = 907
// module chunks = 0